import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items, tone = "light" }: { items: Crumb[]; tone?: "light" | "dark" }) {
  const baseText = tone === "dark" ? "text-background-200/85" : "text-foreground-500";
  const currentText = tone === "dark" ? "text-background-50" : "text-foreground-800";
  const linkText = tone === "dark" ? "text-background-200/85 hover:text-accent-400" : "text-foreground-500 hover:text-primary-700";
  const iconText = tone === "dark" ? "text-background-200/50" : "text-foreground-300";

  return (
    <nav aria-label="面包屑导航" className={`flex flex-wrap items-center gap-2 text-sm ${baseText}`}>
      {items.map((item, index) => (
        <span key={item.label + index} className="flex items-center gap-2">
          {index > 0 && <i className={`ri-arrow-right-s-line ${iconText}`}></i>}
          {item.to ? (
            <Link to={item.to} className={`transition-colors ${linkText}`}>
              {item.label}
            </Link>
          ) : (
            <span className={`font-medium ${currentText}`}>{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}